export const JSON_ONE = {
   
"header": {
"operatingSystem": "android",
"sessionId": "AGGR002557",
"version": "1.0.0"
},
"transaction": {
"requestType": "ONBO",
"requestSubType": "“CHECK”",
"channel": "WEB",
"tranCode": "0",
"txnAmt": "0.0"
}
}

export const JSON_TWO = {
    
"header": {
"operatingSystem": "WEB",
"sessionId": "9e819fb4a264944c6d6453b32489d98",
"version": "1.0.0"
},
"transaction": {
"requestType": "WTW",
"requestSubType": "LMREQ",
"channel": "Web",
"id": "AGGR001158"
},
"loadMoneyModel": {
"txnAmount": "5000.0",
"txnId": "TestLoad50",
"createdBy": "AGGR001158"
}
}

export const JSON_THREE = {
    
"header": {
"operatingSystem": "WEB",
"sessionId": "21a230ad05600edf5374ea98f37f376c61aa0d12a95f88",
"version": "1.0.0"
},
"transaction": {
"requestType": "WTW",
"requestSubType": "LMSL",
"id": "AGGR001158"
},
"loadMoneyModel": {
"usertype": "4.0"
}
}


export const JSON_FOUR = {
    

"header": {
"operatingSystem": "WEB",
"sessionId": "639834816cbd0704b95c4bab",
"userAgent": "Mozilla/5.0 Chrome/80.0.3987.132 Safari/537.36"
},
"transaction": {
"requestType": "WTW",
"requestSubType": "BENEL",
"id": "AGGR001158"
}
}


export const JSON_FIVE = {
 
"header": {
"operatingSystem": "andriod"
},
"userInfo": { },
"transaction": {
"requestType": "WTW",
"requestSubType": "PWTB",
"otp": "088446",
"otp_ref_number": "oWPYHZxmiLXRIDEoVvHL"
},
"payOutBean": {
"mobileNo": "79798****5",
"txnAmount": "2.20",
"accountNo": "351*********09",
"ifscCode": "K*********2",
"bankName": "kotak",
"accountHolderName": "AVPP",
"txnType": "IMPS",
"accountType": "Saving",
"orderRefNo": "PAYO001112"
}
}


export const JSON_SIX = {
    
        "header": {
        "ipAddress": "0.0.0.0",
        "operatingSystem": "WEB",
        "sessionId": "b0f3084dca2fd410e21b50a5c30dbeef9a8410814354ab99c4e04766ca0f6a02"
        },
        "userInfo": { },
        "transaction": {
        "requestType": "TMH",
        "requestSubType": "WTAL",
        "channel": "WEB",
        "tranCode": "0",
        "txnAmount": "0.00"
        },
        "payOutBean": {
        "customerId": "AGGR001158",
        "StartDate": "2020-03-01",
        "EndDate": "2020-03-18"
        }
        }




export const JSON_SEVEN = {
    
    "header": {
    "ipAddress": "0.0.0.0",
    "operatingSystem": "WEB",
    "sessionId": "b0f3084dca2fd410e21b50a5c30dbeef9a8410814354ab99c4e04766ca0f6a02"
    },
    "transaction": {
    "requestType": "TMH",
    "requestSubType": "WTAL",
    "channel": "WEB",
    "tranCode": "0",
    "txnAmount": "0.00"
    },
    "payOutBean": {
    "customerId": "AGGR001158"
    }
    }



export const JSON_EIGHT = {

"header": {
"ipAddress": "0.0.0.0",
"operatingSystem": "WEB",
"sessionId": "b0f3084dca2fd410e21b50a5c30dbeef9a8410814354ab99c4e04766ca0f6a02"
},
"transaction": {
"requestType": "TMH",
"requestSubType": "WTAL",
"channel": "WEB",
"tranCode": "0",
"txnAmount": "0.00"
},
"payOutBean": {
"customerId": "AGGR001158"
}
}


export const JSON_NINE = {

        "header": {
        "operatingSystem": "andriod",
        "sessionId": "AGGR001158"
        },
        "transaction": {
        "requestType": "TMH",
        "requestSubType": "STCHK"
        },
        "payOutBean": {
        "payoutId": "PAYO001229"
        }
        }


export const JSON_TEN = {


    "header": {
        "operatingSystem": "andriod",
        "sessionId": "AGGR001158"
    },
    "transaction": {
        "requestType": "TMH",
        "requestSubType": "STCHK"
    },
    "payOutBean": {
        "payoutId": "PAYO001229"
    }
    }


    export const JSON_ELEVEN = {

        
            "header": {
              "operatingSystem": "andriod",
              "sessionId": "AGGR001158"
            },
            "transaction": {
              "requestType": "TMH",
              "requestSubType": "STCHK"
            },
            "payOutBean": {
              "payoutId": "PAYO001229"
            }
          }